import React from "react";

export default function Base({}) {
	return <>
		<path d="M100 15.9864C100 24.8299 93.1973 31.9728 84.9206 31.9728H15.0794C6.80272 31.9728 0 24.8299 0 15.9864C0 7.14286 6.80272 0 15.0794 0H84.9206C93.1973 0 100 7.14286 100 15.9864ZM100 84.0136C100 92.8571 93.1973 100 84.9206 100H15.0794C6.80272 100 0 92.8571 0 84.0136C0 75.1701 6.80272 68.0272 15.0794 68.0272H84.9206C93.1973 68.0272 100 75.1701 100 84.0136ZM100 50C100 58.8435 93.1973 65.9864 84.9206 65.9864H15.0794C6.80272 65.9864 0 58.8435 0 50C0 41.1565 6.80272 34.0136 15.0794 34.0136H84.9206C93.1973 34.0136 100 41.1565 100 50Z"/>
	</>
}